import script from "./userItem.vue?vue&type=script&setup=true&lang=js"
export * from "./userItem.vue?vue&type=script&setup=true&lang=js"

import "./userItem.vue?vue&type=style&index=0&id=75c10beb&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75c10beb"]])

export default __exports__